import {IPNSUserRolePrivilege} from '@portal-ng/PNSModels/PNSUserRolePrivilege.model';

export interface IPNSRole {
  id: string;
  updatedBy: string;
  name: string;
  privileges: IPNSUserRolePrivilege[];
}
